
<b-badge :variant="parsedVariant" class="pl-3 pr-3 pt-2 pb-1 text-uppercase">
  <slot/>
</b-badge>
